import '@/app/app.css';
import './marketing-consent.css';

import '@/app/app';
import '@/layouts/main/main.js';

window.addEventListener('DOMContentLoaded', () => {});
